import { motion } from "framer-motion";
import { useLanguage } from "@/lib/i18n";
import { resolveImg } from "@/lib/site";

const EASE = [0.22, 1, 0.36, 1];

const IMAGES = [
  { src: "/images/refugio-aereo.png", alt: "Vista aérea da enseada turquesa da Praia da Sete Fontes cercada pela Mata Atlântica" },
  { src: "/images/pescador-ariane.png", alt: "Pescador recolhendo a rede no barco Ariane II, mar de Ubatuba" },
  { src: "/images/guarda-sois-praia.png", alt: "Guarda-sóis na areia com barcos no mar turquesa da Praia da Sete Fontes" },
];

export default function StoryManifesto() {
  const { t, content } = useLanguage();

  return (
    <section
      id="historia"
      data-testid="manifesto-section"
      className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32 lg:px-10"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mb-16 max-w-2xl sm:mb-24"
      >
        <p className="font-jetmono text-xs uppercase tracking-[0.25em] text-[#0D5C63]" data-testid="manifesto-eyebrow">
          {t.manifesto.eyebrow}
        </p>
        <h2 className="mt-4 font-playfair text-3xl leading-tight tracking-tight text-[#1A252C] sm:text-4xl lg:text-5xl">
          {t.manifesto.titleA}{" "}
          <span className="italic text-[#E76F51]">{t.manifesto.titleB}</span>
        </h2>
      </motion.div>

      <div className="space-y-20 sm:space-y-28">
        {t.manifesto.chapters.map((chapter, i) => (
          <motion.article
            key={i}
            data-testid={`manifesto-chapter-0${i + 1}`}
            initial={{ opacity: 0, y: 44 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: EASE }}
            className={`flex flex-col gap-8 md:items-center md:gap-14 ${
              i % 2 === 1 ? "md:flex-row-reverse" : "md:flex-row"
            }`}
          >
            <div className="md:w-1/2">
              <span className="font-playfair text-6xl italic text-[#E76F51]/90 sm:text-7xl">
                0{i + 1}
              </span>
              <h3 className="mt-3 font-cabinet text-xl font-bold tracking-tight text-[#1A252C] sm:text-2xl">
                {chapter.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-[#1A252C]/65 sm:text-lg">
                {chapter.text}
              </p>
            </div>
            <motion.div
              className="md:w-1/2"
              whileHover={{ scale: 0.985 }}
              transition={{ duration: 0.5, ease: EASE }}
            >
              <div className="overflow-hidden rounded-[2rem] border border-[#3D2B1F]/10 shadow-2xl shadow-[#3D2B1F]/10">
                <motion.img
                  src={resolveImg((content.images.storyChapters && content.images.storyChapters[i]) || IMAGES[i].src)}
                  alt={IMAGES[i].alt}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover"
                  initial={{ scale: 1.15 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: EASE }}
                />
              </div>
            </motion.div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
